import React from 'react';
import { useEffectOnce } from 'react-use';

import PropTypes from 'prop-types';
import { FormattedMessage } from '@artemis/integrations/contentful/utils';
import {
  logRequestToJoinBackClick,
  logRequestToJoinImpression,
} from './analytics';
import {
  Body,
  ButtonContainer,
  Container,
  PrimaryButton,
  Title,
} from './shared';

import 'react-loading-skeleton/dist/skeleton.css';

const RequestToJoin = ({ email, onBack }) => {
  useEffectOnce(() => {
    logRequestToJoinImpression({ email });
  });

  return (
    <Container>
      <Title>
        <FormattedMessage entry="teams.requestToJoin.title" />
      </Title>
      <Body>
        <FormattedMessage entry="teams.requestToJoin.description" />
      </Body>
      <ButtonContainer>
        <PrimaryButton
          buttonType="solid"
          color="primary"
          onClick={() => {
            logRequestToJoinBackClick({ email });
            onBack();
          }}
        >
          <FormattedMessage entry="teams.requestToJoin.backButton" />
        </PrimaryButton>
      </ButtonContainer>
    </Container>
  );
};

RequestToJoin.propTypes = {
  email: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default RequestToJoin;
